import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import tasks from "../tasks/tasks";
import { ITask } from "../tasks/types";
import { useBadgeUpdate } from "../../components/search/details/form/hooks/useBadgeUpdate";
import { ComponentWithChildren, IPersonBadge, IProduct } from "../types";
import { badgesSelector } from "../../redux/eventEdition/selectors/eventEdition.selectors";
import { organisationsSelector } from "../../redux/organisations/selectors/organisation.selectors";
import { productsSelector } from "../../redux/magento/selectors/magento.selectors";
import SearchInputDataStore from "../../components/search/input/store/SearchInputDataStore";
import BadgeHelper from "../network/helpers/badges/BadgeHelper";

let tasksStarted = false;
let shouldSubstractTwoHours = true;

const BackgroundTasks: ComponentWithChildren = ({ children }) => {
  const { getUpdatedBadges } = useBadgeUpdate();
  const isAdmin = useSelector((state: RootState) => state.metadata.isAdmin);
  const [intervalIds, setIntervalIds] = useState<number[]>([]);
  const badges: IPersonBadge[] = useSelector(badgesSelector);
  const products: IProduct[] = useSelector(productsSelector);
  const organisations = useSelector(organisationsSelector);

  const updateBadgesCallback = async () => {
    if (!BadgeHelper.isInitialised) {
      return;
    }
    await getUpdatedBadges(shouldSubstractTwoHours ? 120 : 2);
    shouldSubstractTwoHours = false;
  };

  useEffect(() => {
    SearchInputDataStore.updateCompanyFilterOptions(badges, products, organisations);
    SearchInputDataStore.updateStandIdFilterOptions(badges, products);
  }, [badges, products, organisations]);

  useEffect(() => {
    if (isAdmin && !tasksStarted) {
      tasksStarted = true;
      setTimeout(() => {
        const badgeCallback: ITask = { callback: updateBadgesCallback, delay: 45000 };
        const taskArray: ITask[] = [badgeCallback];
        const taskIds = tasks.setupTasks(taskArray);
        setIntervalIds(taskIds);
      }, 60000);
    }
  }, [isAdmin]);

  useEffect(() => {
    return () => {
      tasks.finishTasks(intervalIds);
    };
  }, []);

  return <>{children}</>;
};

export default BackgroundTasks;
